import {
  MOCKEND_ALL_DISABLED,
  MOCKEND_ALL_ENABLED,
  MOCKEND_TIMING,
} from "src/config";
import { MockendConfig } from "src/types";

import getIdToken from "./mocks/getIdToken.json";
import postDraft from "./mocks/postDraft.json";
import getVehicleInfo from "./mocks/getVehicleInfo.json";
import postVehicleDocumentsDraft from "./mocks/postVehicleDocumentsDraft.json";
import deleteVehicleDocumentsDraft from "./mocks/deleteVehicleDocumentsDraft.json";
import getVehicleDocumentsDraft from "./mocks/getVehicleDocumentsDraft.json";
import verifyResponsibility from "./mocks/verifyResponsibility.json";
import getVehicleLicenseTypes from "./mocks/getVehicleLicenseTypes.json";

export const ALL_DISABLED = MOCKEND_ALL_DISABLED;
export const ALL_ENABLED = MOCKEND_ALL_ENABLED;
export const TIMING = MOCKEND_TIMING;

export const CONFIG: MockendConfig = {
  getIdToken: {
    enabled: false,
    status: 200,
    mocks: {
      200: getIdToken,
    },
  },
  getDraft: {
    enabled: false,
    status: 200,
    mocks: {
      200: "",
    },
  },
  postDraft: {
    enabled: false,
    status: 200,
    mocks: {
      200: postDraft,
    },
  },
  getVehicleDraft: {
    enabled: false,
    status: 200,
    mocks: {
      200: "",
    },
  },
  getVehicleInfo: {
    enabled: false,
    status: 200,
    mocks: {
      200: getVehicleInfo,
    },
  },
  verifyResponsibility: {
    enabled: false,
    status: 200,
    mocks: {
      200: verifyResponsibility,
    },
  },
  getAccidentDataDraft: {
    enabled: false,
    status: 200,
    mocks: {
      200: "",
    },
  },
  putAccidentDataDraft: {
    enabled: false,
    status: 200,
    mocks: {
      200: "",
    },
  },
  getVehicleDocumentsDraft: {
    enabled: false,
    status: 200,
    mocks: {
      200: getVehicleDocumentsDraft,
    },
  },
  postVehicleDocumentsDraft: {
    enabled: false,
    status: 200,
    mocks: {
      200: postVehicleDocumentsDraft,
    },
  },
  deleteVehicleDocumentsDraft: {
    enabled: false,
    status: 200,
    mocks: {
      200: deleteVehicleDocumentsDraft,
    },
  },
  postCreateDossier: {
    enabled: false,
    status: 200,
    mocks: {
      200: "",
    },
  },
  postSendDossier: {
    enabled: false,
    status: 200,
    mocks: {
      200: "",
    },
  },
  getVehicleLicenseTypes: {
    enabled: false,
    status: 200,
    mocks: {
      200: getVehicleLicenseTypes,
    },
  },
  getCommunicationToken: {
    enabled: false,
    status: 200,
    mocks: {
      200: "",
    },
  },
};
